import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";

export const handleNoteError = (error: unknown, fallbackMessage: string): void => {
  Sentry.captureException(error, { tags: { feature: "snapshot-notes" } });
  console.error(fallbackMessage, error);

  if (error && typeof error === "object" && "status" in error) {
    const apiError = error as { status: number; data?: { detail?: string } };
    if (apiError.status === 403) {
      toast.error("You don't have permission to edit this snapshot");
      return;
    }
    if (apiError.status === 404) {
      toast.error(apiError.data?.detail ?? "Note not found");
      return;
    }
    if (apiError.status === 409) {
      toast.error(apiError.data?.detail ?? "Name already exists");
      return;
    }
    if (apiError.data?.detail) {
      toast.error(apiError.data.detail);
      return;
    }
  }

  toast.error(fallbackMessage);
};
